export const getDistanceFromTop = (elem: HTMLElement | Window) => {
  if (elem instanceof Window) {
    return elem.scrollY || elem.pageYOffset
  }

  return elem.scrollTop
}
